export default {"src":"/_next/static/image/public/images/pay_on_delivery.6ed61105cc55a0b77313fda45511cf75.svg","height":36,"width":36};